import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, mergeMap, retry, retryWhen } from 'rxjs/operators';
// import { TransactionCacheService } from '../services/transaction/transaction-cache.service';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  // Configuración para los reintentos
  private maxRetries = 3;
  private initialDelay = 1000; // 1 segundo
  private backoffFactor = 2; // Tiempo de espera exponencial
  
  // URLs que deben ser interceptadas para reintentos
  private retryableUrls = [
    '/getUserBalance',
    '/investDigitalWallet',
    '/payment',
    '/purchases'
  ];

  constructor() {} // Comentado temporalmente: private cacheService: TransactionCacheService

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Verificar si la URL debe ser tratada con lógica de reintento
    const shouldRetry = this.retryableUrls.some(url => request.url.includes(url));
    
    if (!shouldRetry) {
      // Si no es una URL que debemos reintentar, continuar normalmente
      return next.handle(request);
    }
    
    // Extraer projectId y amount del cuerpo de la solicitud si están disponibles
    let projectId: string | null = null;
    let amount: number | null = null;
    
    if (request.body && typeof request.body === 'object') {
      const body = request.body as any;
      projectId = body.projectId || null;
      amount = body.totalAmount ? body.totalAmount / 100 : null;
    }
    
    // Comentado temporalmente - registrar la transacción en caché si tenemos los datos necesarios
    // if (projectId && amount) {
    //   this.cacheService.registerTransaction(projectId, amount);
    // }

    // Aplicar estrategia de reintentos con backoff exponencial
    return next.handle(request).pipe(
      retryWhen(errors => 
        errors.pipe(
          mergeMap((error, attempt) => {
            // Solo reintentar errores de servidor (500) y hasta maxRetries
            if (attempt >= this.maxRetries || !(error instanceof HttpErrorResponse) || error.status !== 500) {
              return throwError(() => error);
            }
            
            console.log(`📡 Reintento ${attempt+1}/${this.maxRetries} para solicitud ${request.url}`);
            
            // Comentado temporalmente - actualizar estado en caché si tenemos projectId
            // if (projectId) {
            //   this.cacheService.updateTransactionStatus(projectId, 'RETRYING');
            // }
            
            // Delay exponencial entre reintentos
            const delay = this.initialDelay * Math.pow(this.backoffFactor, attempt);
            return timer(delay);
          })
        )
      ),
      catchError((error: HttpErrorResponse) => {
        // Comentado temporalmente - actualizar estado en caché si tenemos projectId
        // if (projectId) {
        //   this.cacheService.updateTransactionStatus(
        //     projectId, 
        //     error.status === 500 ? 'FAILED_SERVER' : 'FAILED_CLIENT'
        //   );
        // }
        
        // Log detallado del error
        console.error(`🔴 Error ${error.status} en solicitud ${request.url}`, error);
        
        // Propagar el error
        return throwError(() => error);
      })
    );
  }
}
